<template>
    <v-layout column>
        <v-fade-transition mode="out-in">
            <label v-if="!loading" class="display-1 font-weight-reqular">{{count}}%</label>
            <v-progress-circular indeterminate
                                 v-else
                                 style="margin-top: 5px; margin-bottom: 3px;"
                                 color="secondary"/>
        </v-fade-transition>
        <label class="subtitle-2 font-weight-regular">{{label}}</label>
    </v-layout>
</template>

<script>
    export default {
        name: "percent",
        props: {
            count: {
                type: Number,
                required: true
            },
            loading: {
                type: Boolean,
                required: true
            },
            label: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped>

</style>